/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class Unauthorizedinterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: MsalService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        console.error(err);
        if (err.status == 403) {
          this.router.navigate(['access-forbidden']);
        }
        if (err.status == 401) {
          console.error('CONSENT test, error:', err);
          if (err.error.suberror == 'consent_required') {
            console.error('consent required');
            next.handle(req);
            // this.authService.instance.acquireTokenSilent({
            //   err.req
            // }) // .AcquireTokenInteractive(scopes).WithClaims(wwwParams.Claims);
          }
          //this.authService.
        }

        return throwError(() => err);
      })
    );
  }
}
